import script from "./GovNotifyServiceConfiguration.vue?vue&type=script&lang=ts&setup=true"
export * from "./GovNotifyServiceConfiguration.vue?vue&type=script&lang=ts&setup=true"

import "./GovNotifyServiceConfiguration.vue?vue&type=style&index=0&id=11f515d7&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11f515d7"]])

export default __exports__